module.exports = __webpack_public_path__ + "static/media/amusement(22).b3cbbf22.PNG";